app.factory('patientService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

	    function PatientService() {

			function translateAddressesToVO(patient) {
				if(patient.registeredAddress && !(patient.registeredAddress instanceof AddressVO)) {
					patient.registeredAddress = objectHelper.translateObject(patient.registeredAddress, AddressVO);
				}
				if(patient.correspondenceAddress && !(patient.correspondenceAddress instanceof AddressVO)) {
					patient.correspondenceAddress = objectHelper.translateObject(patient.correspondenceAddress, AddressVO);
				}
			}

			this.getById = function(id) {
				var d = $q.defer();

				baseService.get(config.API_URL + '/patients/' + id).then(
					function(successResponse) {
						var data = objectHelper.translateObject(successResponse, PatientVO);
						data = objectHelper.convertTimesToDates(data);

						d.resolve(data);
					},
					function(errorResponse) {
						d.reject(errorResponse);
					}
				);

				return d.promise;
			};

			this.getDataPage = function (criteria) {
				return baseService.post(config.API_URL + '/patients/dataPage', criteria).then(
					function (successResponse) {
						var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
						dataPage.data = objectHelper.translateArray(dataPage.data, PatientVO);
						dataPage = objectHelper.convertTimesToDates(dataPage);
						return dataPage;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.getStateOfHealth = function(id) {
				var d = $q.defer();

				baseService.get(config.API_URL + '/patients/' + id + '/stateOfHealthSummary').then(
					function(successResponse) {
						var data = objectHelper.translateObject(successResponse, StateOfHealthWrapperVO);
						data.allergies.data = objectHelper.translateArray(data.allergies.data, AllergyVO);
						data.geneticDisorders.data = objectHelper.translateArray(data.geneticDisorders.data, GeneticDisorderVO);
						data.hospitalsAndSanatorium.data = objectHelper.translateArray(data.hospitalsAndSanatorium.data, HospitalAndSanatoriumVO);
						data.laboratoryTestResults.data = objectHelper.translateArray(data.laboratoryTestResults.data, LaboratoryTestResultVO);
						data.vaccinationsAndSerum.data = objectHelper.translateArray(data.vaccinationsAndSerum.data, VaccinationAndSerumVO);
						data.takenDrugs.data = objectHelper.translateArray(data.takenDrugs.data, PrescribedDrugVO);
						data.medicalProcedures.data = objectHelper.translateArray(data.medicalProcedures.data, MedicalProcedureVO);
						data.chronicDiagnosis.data = objectHelper.translateArray(data.chronicDiagnosis.data, DiagnosisVO);
						data.nonChronicDiagnosis.data = objectHelper.translateArray(data.nonChronicDiagnosis.data, DiagnosisVO);
						data = objectHelper.convertTimesToDates(data);

						d.resolve(data);
					},
					function(errorResponse) {
						d.reject(errorResponse);
					}
				);

				return d.promise;
			};

			this.getStateOfHealthSummaryWithDeleted = function(id) {
				var d = $q.defer();

				baseService.get(config.API_URL + '/patients/' + id + '/stateOfHealthSummaryWithDeleted').then(
					function(successResponse) {
						var data = objectHelper.translateObject(successResponse, StateOfHealthWrapperVO);
						data.allergies.data = objectHelper.translateArray(data.allergies.data, AllergyVO);
						data.geneticDisorders.data = objectHelper.translateArray(data.geneticDisorders.data, GeneticDisorderVO);
						data.hospitalsAndSanatorium.data = objectHelper.translateArray(data.hospitalsAndSanatorium.data, HospitalAndSanatoriumVO);
						data.laboratoryTestResults.data = objectHelper.translateArray(data.laboratoryTestResults.data, LaboratoryTestResultVO);
						data.vaccinationsAndSerum.data = objectHelper.translateArray(data.vaccinationsAndSerum.data, VaccinationAndSerumVO);
						data.takenDrugs.data = objectHelper.translateArray(data.takenDrugs.data, TakenDrugVO);
						data.medicalProcedures.data = objectHelper.translateArray(data.medicalProcedures.data, MedicalProcedureVO);
						data.chronicDiagnosis.data = objectHelper.translateArray(data.chronicDiagnosis.data, DiagnosisVO);
						data.nonChronicDiagnosis.data = objectHelper.translateArray(data.nonChronicDiagnosis.data, DiagnosisVO);
						data = objectHelper.convertTimesToDates(data);

						d.resolve(data);
					},
					function(errorResponse) {
						d.reject(errorResponse);
					}
				);

				return d.promise;
			};

			this.save = function (patient) {
				translateAddressesToVO(patient);
				patient = objectHelper.convertDatesToTimes(patient)
				return baseService.post(config.API_URL + '/patients', patient).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, PatientVO);
						return data;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.update = function (patient) {
				translateAddressesToVO(patient);
				patient = objectHelper.convertDatesToTimes(patient);
				return baseService.post(config.API_URL + '/patients/' + patient.id, patient).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, PatientVO);
						return data;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.delete = function (patient) {
				translateAddressesToVO(patient);
				patient = objectHelper.convertDatesToTimes(patient);
				return baseService.delete(config.API_URL + '/patients/' + patient.id).then(
					function (successResponse) {
						return successResponse;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.saveAuthorizedPerson = function(patient, authorizedPerson) {
				authorizedPerson = objectHelper.convertDatesToTimes(authorizedPerson);
				return baseService.post(config.API_URL + '/patients/' + patient.id + '/authorizedPersons', authorizedPerson).then(
					function (successResponse) {
						return objectHelper.translateObject(successResponse, AuthorizedPersonVO);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.updateAuthorizedPerson = function(patient, authorizedPerson) {
				authorizedPerson = objectHelper.convertDatesToTimes(authorizedPerson);
				return baseService.post(config.API_URL + '/patients/' + patient.id + '/authorizedPersons/' + authorizedPerson.id, authorizedPerson).then(
					function (successResponse) {
						return objectHelper.translateObject(successResponse, AuthorizedPersonVO);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.deleteAuthorizedPerson = function(patient, authorizedPerson) {
				return baseService.delete(config.API_URL + '/patients/' + patient.id + '/authorizedPersons/' + authorizedPerson.id).then(
					function (successResponse) {
						return successResponse;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.saveAttachment = function(patient, attachment) {
				attachment = objectHelper.convertDatesToTimes(attachment);
				return baseService.post(config.API_URL + '/patients/' + patient.id + '/attachments', attachment).then(
					function (successResponse) {
						return objectHelper.translateObject(successResponse, AttachmentVO);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.updateAttachment = function(patient, attachment) {
				attachment = objectHelper.convertDatesToTimes(attachment);
				return baseService.post(config.API_URL + '/patients/' + patient.id + '/attachments/' + attachment.id, attachment).then(
					function (successResponse) {
						return objectHelper.translateObject(successResponse, AttachmentVO);
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.deleteAttachment = function(patient, attachment) {
				return baseService.delete(config.API_URL + '/patients/' + patient.id + '/attachments/' + attachment.id).then(
					function (successResponse) {
						return successResponse;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
	        
	    }
	
	    return new PatientService();
	}
]);
